import { useLocation } from 'react-router-dom';
import NavLink from '../../shared/buttons/nav-link';
import ButtonGroup from '../../shared/buttons/button-group';
import LogoutButton from './logout-button';
import { useUser } from '../../../hooks/react-query/use-user';
import { getLoginRedirectURL } from '../../../utils/url';
import { UserCircleIcon } from '@heroicons/react/24/outline';

type AuthHeaderProps = { className?: string };

function AuthHeader(props: AuthHeaderProps) {
  const location = useLocation();
  const { status, data: user } = useUser();

  if (status === 'error') {
    return (
      <ButtonGroup className={props.className}>
        <NavLink
          to={getLoginRedirectURL(location.pathname, location.search)}
          color='cyan'
          colorWeight={600}
          content='ورود'
          className={props.className}
        />
        <NavLink
          to='/register'
          color='cyan'
          colorWeight={600}
          content='ثبت نام'
          className={props.className}
        />
      </ButtonGroup>
    );
  }

  return (
    <ButtonGroup className={props.className}>
      <NavLink
        to='/profile'
        color='cyan'
        colorWeight={600}
        loading={status === 'loading'}
        disabled={status === 'loading'}
      >
        <span className='hidden 2xs:inline'>{user?.name || user?.mobile}</span>
        <UserCircleIcon width={20} height={20} className='2xs:hidden' />
      </NavLink>
      <LogoutButton isLoading={status === 'loading'} isDisabled={status === 'loading'} />
    </ButtonGroup>
  );
}

export default AuthHeader;
